import request from './request'

export const getCommunityList = (params) => {
  return request({
    url: '/admin/communities',
    method: 'get',
    params
  })
}

export const getCommunityDetail = (id) => {
  return request({
    url: `/admin/communities/${id}`,
    method: 'get'
  })
}

export const getCommunityRunners = (communityId) => {
  return request({
    url: `/admin/communities/${communityId}/runners`,
    method: 'get'
  })
}

export const getCommunityShops = (communityId) => {
  return request({
    url: `/admin/communities/${communityId}/shops`,
    method: 'get'
  })
}

export const createCommunity = (data) => {
  return request({
    url: '/admin/communities',
    method: 'post',
    data
  })
}

export const updateCommunity = (id, data) => {
  return request({
    url: `/admin/communities/${id}`,
    method: 'put',
    data
  })
}

export const deleteCommunity = (id) => {
  return request({
    url: `/admin/communities/${id}`,
    method: 'delete'
  })
}

export const getBuildingList = (communityId) => {
  return request({
    url: `/admin/communities/${communityId}/buildings`,
    method: 'get'
  })
}

export const getBuildingDetail = (id) => {
  return request({
    url: `/admin/buildings/${id}`,
    method: 'get'
  })
}

export const createBuilding = (communityId, data) => {
  return request({
    url: `/admin/communities/${communityId}/buildings`,
    method: 'post',
    data
  })
}

export const updateBuilding = (id, data) => {
  return request({
    url: `/admin/buildings/${id}`,
    method: 'put',
    data
  })
}

export const deleteBuilding = (id) => {
  return request({
    url: `/admin/buildings/${id}`,
    method: 'delete'
  })
}

export const getWeatherTypeOptions = () => {
  return request({
    url: '/admin/weather-types/options',
    method: 'get'
  })
}
